import React from 'react'
import { useAppSelector } from '@redux/index'
import { BoSizeClass } from './backoffice.tokens'

export interface BoShellContextType {
	sizeClass: BoSizeClass
	/**
	 * 사이드바 항목이 펼쳐진 상태로 그려지는가.
	 * 데스크톱 = redux `isOpenDrawer` · 태블릿 레일 = false · 임시 드로어(폰·태블릿 펼침) = true.
	 * 사이드바 안 컴포넌트는 redux 대신 `useDrawerOpen()` 으로 이 값을 읽는다 (RESPONSIVE_PLAN §4).
	 */
	drawerOpen: boolean | null
	/** 폰·태블릿 임시 드로어 열림 — persist 하지 않는다 */
	mobileDrawerOpen: boolean
	setMobileDrawerOpen: (open: boolean) => void
}

export const BoShellContext = React.createContext<BoShellContextType>({
	sizeClass: 'desktop',
	drawerOpen: null,
	mobileDrawerOpen: false,
	setMobileDrawerOpen: () => {},
})

export const useBoShell = (): BoShellContextType => React.useContext(BoShellContext)

/** 사이드바 펼침 여부 — 쉘이 정해 주면 그것, 아니면 redux */
export const useDrawerOpen = (): boolean => {
	const ctx = React.useContext(BoShellContext)
	const reduxOpen: boolean = useAppSelector(state => state.config.isOpenDrawer)
	return ctx.drawerOpen ?? reduxOpen
}
